<template>
  <div class="pizzeria-italia">
    <!-- Top bar -->
    <div class="top-bar">
      <div class="container">
        <div class="top-links">
          <span>🍕 ¡Pizzas artesanales!</span>
          <span>🚚 Envío gratis desde S/40</span>
          <span>📞 +51 928 180 748</span>
        </div>
      </div>
    </div>

    <!-- Header -->
    <div class="main-header">
      <div class="container">
        <div class="header-row">
          <div class="logo" @click="goBack">
            <span class="logo-icon">🍕</span>
            <span class="logo-text">Pizzeria<span class="logo-red">Italia</span></span>
          </div>
          <div class="delivery-info">
            <span>📍 Delivery a domicilio</span>
            <span>⏰ 11am - 11pm</span>
          </div>
          <div class="cart-floating-small" @click="verCarrito">
            <span>🛒</span>
            <span class="cart-count-small">{{ carrito.length }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Hero Banner -->
    <div class="hero-banner">
      <div class="container">
        <div class="hero-content">
          <div class="hero-text">
            <h1>¡La mejor pizza artesanal!</h1>
            <p>Masa madre, ingredientes frescos y el auténtico sabor italiano</p>
            <div class="hero-buttons">
              <button class="btn-primary" @click="scrollToProductos">Ver menú →</button>
              <button class="btn-secondary" @click="verOfertas">
                Ofertas especiales
              </button>
            </div>
          </div>
          <div class="hero-image">🍕🔥</div>
        </div>
      </div>
    </div>

    <!-- Promo banner -->
    <div class="promo-banner">
      <div class="container">
        <div class="promo-content">
          <span>🎁 Lleva 2 pizzas grandes y llévate una bebida 1L GRATIS</span>
          <span class="promo-code">Código: PIZZA2X1</span>
        </div>
      </div>
    </div>

    <!-- Categorías (tipos de pizza) -->
    <div class="categories-section">
      <div class="container">
        <div class="section-title">
          <h2>🍕 Nuestras especialidades</h2>
        </div>
        <div class="categories-grid">
          <div
            v-for="cat in categorias"
            :key="cat.nombre"
            class="cat-card"
            @click="filtrarPorCategoria(cat.nombre)"
          >
            <div class="cat-emoji">{{ cat.icono }}</div>
            <h3>{{ cat.nombre }}</h3>
            <p>{{ cat.descripcion }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Menú de pizzas -->
    <div id="productos" class="menu-section">
      <div class="container">
        <div class="section-header">
          <h2>🔥 Nuestro menú</h2>
          <div class="filters">
            <button
              v-for="filtro in filtros"
              :key="filtro"
              :class="{ active: filtroActivo === filtro }"
              @click="filtroActivo = filtro"
            >
              {{ filtro }}
            </button>
          </div>
        </div>

        <div v-if="pizzasFiltradas.length === 0" class="no-results">
          <p>No encontramos pizzas</p>
        </div>

        <div class="pizzas-grid">
          <div v-for="pizza in pizzasFiltradas" :key="pizza.id" class="pizza-card">
            <div v-if="pizza.oferta" class="pizza-badge">
              🔥 {{ pizza.descuento }}% OFF
            </div>
            <div class="pizza-img">{{ pizza.icono }}</div>
            <div class="pizza-info">
              <h3>{{ pizza.nombre }}</h3>
              <p class="pizza-ingredientes">{{ pizza.ingredientes }}</p>
              <div class="pizza-tamaños">
                <span v-for="t in pizza.tamaños" :key="t.tamaño" class="tamaño-badge">
                  {{ t.tamaño }}: S/ {{ t.precio }}
                </span>
              </div>
              <div class="pizza-footer">
                <div class="pizza-rating">
                  ⭐ {{ pizza.rating }} ({{ pizza.reviews }})
                </div>
                <button class="add-btn" @click="agregarAlCarrito(pizza)">
                  🛒 Agregar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Combos especiales -->
    <div class="combos-section">
      <div class="container">
        <div class="section-title">
          <h2>🎁 Combos especiales</h2>
          <p>¡Ahorra más con nuestros combos!</p>
        </div>
        <div class="combos-grid">
          <div v-for="combo in combos" :key="combo.nombre" class="combo-card">
            <div class="combo-img">🍕🥤🍟</div>
            <h3>{{ combo.nombre }}</h3>
            <p>{{ combo.descripcion }}</p>
            <div class="combo-price">S/ {{ combo.precio }}</div>
            <div class="combo-old">S/ {{ combo.precio_anterior }}</div>
            <button class="combo-btn" @click="agregarCombo(combo)">Agregar combo</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Beneficios -->
    <div class="benefits-section">
      <div class="container">
        <div class="benefits-grid">
          <div class="benefit">
            <div>🍕</div>
            <h4>Masa artesanal</h4>
            <p>Fermentación 24 horas</p>
          </div>
          <div class="benefit">
            <div>🧀</div>
            <h4>Ingredientes frescos</h4>
            <p>Productos de calidad</p>
          </div>
          <div class="benefit">
            <div>🚚</div>
            <h4>Delivery gratis</h4>
            <p>Compras > S/40</p>
          </div>
          <div class="benefit">
            <div>⭐</div>
            <h4>Puntos pizza</h4>
            <p>Acumula y canjea</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer">
      <div class="container">
        <div class="footer-grid">
          <div>
            <h4>Pizzeria Italia</h4>
            <p>Auténtica pizza artesanal</p>
          </div>
          <div>
            <h4>Horario</h4>
            <p>Lun-Dom: 11am - 11pm</p>
          </div>
          <div>
            <h4>Contacto</h4>
            <p>📞 +51 928 180 748</p>
            <p>📍 Av. Italia 123, Lima</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2024 Pizzeria Italia - Todos los derechos reservados</p>
        </div>
      </div>
    </div>

    <!-- ========== CARRITO FLOTANTE ========== -->
    <div class="cart-floating" @click="verCarrito">
      <div class="cart-icon">
        🛒
        <span class="cart-badge">{{ carrito.length }}</span>
      </div>
      <div class="cart-total">S/ {{ totalCarrito }}</div>
    </div>

    <!-- Modal carrito -->
    <div v-if="mostrarCarrito" class="modal-overlay" @click.self="cerrarCarrito">
      <div class="modal-container">
        <div class="modal-header">
          <h3>🛒 Tu pedido</h3>
          <button class="modal-close" @click="cerrarCarrito">✕</button>
        </div>
        <div class="modal-body">
          <div v-if="carrito.length === 0" class="empty-cart">
            <div>🍕</div>
            <p>Tu pedido está vacío</p>
            <button @click="cerrarCarrito">Ver menú</button>
          </div>
          <div v-else>
            <div v-for="(item, idx) in carrito" :key="item.id" class="cart-item">
              <div class="cart-item-info">
                <div class="cart-item-name">{{ item.nombre }}</div>
                <div class="cart-item-price">S/ {{ item.precio }}</div>
              </div>
              <div class="cart-item-actions">
                <button @click="disminuirCantidad(idx)">-</button>
                <span>{{ item.cantidad }}</span>
                <button @click="aumentarCantidad(idx)">+</button>
                <button class="remove-btn" @click="eliminarDelCarrito(idx)">🗑️</button>
              </div>
            </div>
            <div class="cart-total-row">
              <span>Total:</span>
              <strong>S/ {{ totalCarrito }}</strong>
            </div>
            <button class="checkout-btn" @click="irAPagar">Confirmar pedido →</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pago -->
    <div v-if="mostrarPago" class="modal-overlay" @click.self="cerrarPago">
      <div class="modal-container modal-pago">
        <div class="modal-header">
          <h3>🍕 Confirmar pedido</h3>
          <button class="modal-close" @click="cerrarPago">✕</button>
        </div>
        <div class="modal-body">
          <div class="order-summary">
            <div v-for="item in carrito" :key="item.id" class="order-item">
              <span>{{ item.nombre }} x {{ item.cantidad }}</span>
              <span>S/ {{ item.precio * item.cantidad }}</span>
            </div>
            <div class="order-total">Total: S/ {{ totalCarrito }}</div>
          </div>
          <input
            type="text"
            v-model="pedido.nombre"
            placeholder="Tu nombre"
            class="input-field"
          />
          <input
            type="text"
            v-model="pedido.direccion"
            placeholder="Dirección de entrega"
            class="input-field"
          />
          <input
            type="text"
            v-model="pedido.telefono"
            placeholder="Teléfono"
            class="input-field"
          />
          <textarea
            v-model="pedido.notas"
            placeholder="Notas adicionales (¿alguna alergia? ¿salsas extra?)"
            class="textarea-field"
          ></textarea>
          <div class="payment-methods">
            <label
              ><input type="radio" value="efectivo" v-model="pedido.pago" /> 💵 Efectivo
              contra entrega</label
            >
            <label
              ><input type="radio" value="tarjeta" v-model="pedido.pago" /> 💳 Tarjeta (al
              delivery)</label
            >
            <label
              ><input type="radio" value="yape" v-model="pedido.pago" /> 📱 Yape</label
            >
          </div>
          <button class="pay-btn" @click="confirmarPedido">Hacer pedido</button>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <div v-if="toastVisible" class="toast">
      {{ toastMensaje }}
    </div>
  </div>
</template>

<script>
export default {
  name: "PizzeriaItalia",
  data() {
    return {
      filtroActivo: "Todos",
      filtros: ["Todos", "Clásicas", "Especiales", "Vegetarianas"],
      mostrarCarrito: false,
      mostrarPago: false,
      toastVisible: false,
      toastMensaje: "",
      carrito: [],
      pedido: { nombre: "", direccion: "", telefono: "", notas: "", pago: "efectivo" },
      categorias: [
        { nombre: "Clásicas", icono: "🍕", descripcion: "Las tradicionales italianas" },
        { nombre: "Especiales", icono: "🔥", descripcion: "Ingredientes premium" },
        { nombre: "Vegetarianas", icono: "🌱", descripcion: "Sin carne, mucho sabor" },
        { nombre: "Pizzas dulces", icono: "🍫", descripcion: "Postres en pizza" },
      ],
      pizzas: [
        {
          id: 1,
          nombre: "Margherita",
          tipo: "Clásicas",
          icono: "🍕",
          ingredientes: "Salsa de tomate, mozzarella, albahaca fresca",
          rating: 4.9,
          reviews: 234,
          oferta: false,
          tamaños: [
            { tamaño: "Personal", precio: 18 },
            { tamaño: "Mediana", precio: 32 },
            { tamaño: "Familiar", precio: 48 },
          ],
        },
        {
          id: 2,
          nombre: "Pepperoni",
          tipo: "Clásicas",
          icono: "🍕",
          ingredientes: "Salsa de tomate, mozzarella, pepperoni",
          rating: 4.8,
          reviews: 189,
          oferta: true,
          descuento: 20,
          tamaños: [
            { tamaño: "Personal", precio: 22 },
            { tamaño: "Mediana", precio: 38 },
            { tamaño: "Familiar", precio: 58 },
          ],
        },
        {
          id: 3,
          nombre: "Hawaiana",
          tipo: "Especiales",
          icono: "🍍",
          ingredientes: "Salsa de tomate, mozzarella, jamón, piña",
          rating: 4.7,
          reviews: 156,
          oferta: false,
          tamaños: [
            { tamaño: "Personal", precio: 20 },
            { tamaño: "Mediana", precio: 36 },
            { tamaño: "Familiar", precio: 54 },
          ],
        },
        {
          id: 4,
          nombre: "Cuatro Quesos",
          tipo: "Especiales",
          icono: "🧀",
          ingredientes: "Mozzarella, parmesano, gorgonzola, ricotta",
          rating: 4.9,
          reviews: 278,
          oferta: true,
          descuento: 15,
          tamaños: [
            { tamaño: "Personal", precio: 24 },
            { tamaño: "Mediana", precio: 42 },
            { tamaño: "Familiar", precio: 64 },
          ],
        },
        {
          id: 5,
          nombre: "Vegetariana",
          tipo: "Vegetarianas",
          icono: "🌿",
          ingredientes: "Champiñones, pimientos, aceitunas, cebolla",
          rating: 4.6,
          reviews: 98,
          oferta: false,
          tamaños: [
            { tamaño: "Personal", precio: 20 },
            { tamaño: "Mediana", precio: 35 },
            { tamaño: "Familiar", precio: 52 },
          ],
        },
        {
          id: 6,
          nombre: "Napolitana",
          tipo: "Clásicas",
          icono: "🍕",
          ingredientes: "Tomate, ajo, orégano, anchoas",
          rating: 4.7,
          reviews: 112,
          oferta: false,
          tamaños: [
            { tamaño: "Personal", precio: 19 },
            { tamaño: "Mediana", precio: 34 },
            { tamaño: "Familiar", precio: 50 },
          ],
        },
        {
          id: 7,
          nombre: "Pizza Nutella",
          tipo: "Pizzas dulces",
          icono: "🍫",
          ingredientes: "Nutella, fresas, plátano",
          rating: 4.9,
          reviews: 201,
          oferta: false,
          tamaños: [
            { tamaño: "Personal", precio: 16 },
            { tamaño: "Mediana", precio: 28 },
          ],
        },
        {
          id: 8,
          nombre: "BBQ Chicken",
          tipo: "Especiales",
          icono: "🍗",
          ingredientes: "Pollo, salsa BBQ, cebolla, cilantro",
          rating: 4.8,
          reviews: 167,
          oferta: true,
          descuento: 18,
          tamaños: [
            { tamaño: "Personal", precio: 23 },
            { tamaño: "Mediana", precio: 40 },
            { tamaño: "Familiar", precio: 60 },
          ],
        },
      ],
      combos: [
        {
          nombre: "Combo Familiar",
          descripcion: "1 Pizza Familiar + 1 Gaseosa 1.5L",
          precio: 55,
          precio_anterior: 70,
        },
        {
          nombre: "Combo Pareja",
          descripcion: "2 Pizzas Medianas + 2 Gaseosas",
          precio: 60,
          precio_anterior: 80,
        },
        {
          nombre: "Combo Personal",
          descripcion: "1 Pizza Personal + 1 Gaseosa",
          precio: 25,
          precio_anterior: 35,
        },
      ],
    };
  },
  computed: {
    pizzasFiltradas() {
      if (this.filtroActivo === "Todos") return this.pizzas;
      return this.pizzas.filter((p) => p.tipo === this.filtroActivo);
    },
    totalCarrito() {
      return this.carrito.reduce((t, i) => t + i.precio * i.cantidad, 0);
    },
  },
  methods: {
    goBack() {
      window.location.href = "/portafolio";
    },
    scrollToProductos() {
      document.getElementById("productos").scrollIntoView({ behavior: "smooth" });
    },
    verOfertas() {
      this.showToast("🎁 2x1 en pizzas medianas los martes");
    },
    filtrarPorCategoria(cat) {
      this.filtroActivo = cat;
      this.scrollToProductos();
    },
    agregarAlCarrito(pizza) {
      const exist = this.carrito.find((i) => i.id === pizza.id);
      if (exist) exist.cantidad++;
      else this.carrito.push({ ...pizza, cantidad: 1 });
      this.showToast(`🍕 ${pizza.nombre} agregada al pedido`);
    },
    agregarCombo(combo) {
      this.carrito.push({
        id: Date.now(),
        nombre: combo.nombre,
        precio: combo.precio,
        cantidad: 1,
      });
      this.showToast(`🎁 ${combo.nombre} agregado`);
    },
    aumentarCantidad(i) {
      this.carrito[i].cantidad++;
    },
    disminuirCantidad(i) {
      if (this.carrito[i].cantidad > 1) this.carrito[i].cantidad--;
      else this.eliminarDelCarrito(i);
    },
    eliminarDelCarrito(i) {
      this.carrito.splice(i, 1);
      this.showToast("🗑️ Producto eliminado");
    },
    verCarrito() {
      this.mostrarCarrito = true;
    },
    cerrarCarrito() {
      this.mostrarCarrito = false;
    },
    irAPagar() {
      this.mostrarCarrito = false;
      this.mostrarPago = true;
    },
    cerrarPago() {
      this.mostrarPago = false;
    },
    confirmarPedido() {
      if (!this.pedido.nombre || !this.pedido.direccion) {
        this.showToast("⚠️ Completa tus datos de entrega");
        return;
      }
      this.showToast(`🍕 ¡Gracias ${this.pedido.nombre}! Tu pedido llegará en 30-45 min`);
      setTimeout(() => {
        this.carrito = [];
        this.mostrarPago = false;
        this.pedido = {
          nombre: "",
          direccion: "",
          telefono: "",
          notas: "",
          pago: "efectivo",
        };
      }, 2500);
    },
    showToast(msg) {
      this.toastMensaje = msg;
      this.toastVisible = true;
      setTimeout(() => {
        this.toastVisible = false;
      }, 3000);
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.pizzeria-italia {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
  background: #fff9f5;
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Top bar */
.top-bar {
  background: #8b0000;
  color: white;
  padding: 8px 0;
  font-size: 13px;
}
.top-links {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
}

/* Header */
.main-header {
  background: white;
  padding: 15px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.logo-icon {
  font-size: 32px;
}
.logo-text {
  font-size: 24px;
  font-weight: bold;
}
.logo-red {
  color: #cc0000;
}
.delivery-info {
  display: flex;
  gap: 20px;
  color: #666;
  font-size: 14px;
}
.cart-floating-small {
  background: #cc0000;
  border-radius: 30px;
  padding: 8px 16px;
  display: flex;
  gap: 8px;
  cursor: pointer;
  color: white;
}
.cart-count-small {
  background: white;
  color: #cc0000;
  border-radius: 50%;
  padding: 0 6px;
  font-size: 12px;
}

/* Hero */
.hero-banner {
  background: linear-gradient(135deg, #cc0000 0%, #8b0000 100%);
  padding: 50px 0;
}
.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.hero-text h1 {
  font-size: 42px;
  color: white;
  margin-bottom: 15px;
}
.hero-text p {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 25px;
}
.hero-buttons {
  display: flex;
  gap: 15px;
}
.btn-primary {
  background: white;
  color: #cc0000;
  border: none;
  padding: 12px 28px;
  border-radius: 30px;
  font-weight: bold;
  cursor: pointer;
}
.btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 12px 28px;
  border-radius: 30px;
  cursor: pointer;
}
.hero-image {
  font-size: 80px;
}

/* Promo banner */
.promo-banner {
  background: #ffd700;
  padding: 12px 0;
  text-align: center;
  font-weight: bold;
}
.promo-content {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}
.promo-code {
  background: #cc0000;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
}

/* Categories */
.categories-section {
  padding: 50px 0;
  background: white;
}
.section-title {
  text-align: center;
  margin-bottom: 40px;
}
.section-title h2 {
  font-size: 32px;
  color: #333;
}
.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 25px;
}
.cat-card {
  text-align: center;
  padding: 25px;
  background: #fff9f5;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #ffe0cc;
}
.cat-card:hover {
  transform: translateY(-5px);
  border-color: #cc0000;
}
.cat-emoji {
  font-size: 48px;
  margin-bottom: 12px;
}
.cat-card h3 {
  color: #333;
  margin-bottom: 8px;
}
.cat-card p {
  font-size: 13px;
  color: #999;
}

/* Menu */
.menu-section {
  padding: 50px 0;
  background: #fff9f5;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 15px;
}
.filters {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.filters button {
  background: white;
  border: 1px solid #ddd;
  padding: 8px 20px;
  border-radius: 30px;
  cursor: pointer;
}
.filters button.active {
  background: #cc0000;
  color: white;
  border-color: #cc0000;
}

.pizzas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 25px;
}
.pizza-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}
.pizza-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}
.pizza-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: #cc0000;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
}
.pizza-img {
  background: #fff0e6;
  text-align: center;
  padding: 30px;
  font-size: 60px;
}
.pizza-info {
  padding: 20px;
}
.pizza-info h3 {
  font-size: 18px;
  margin-bottom: 8px;
  color: #333;
}
.pizza-ingredientes {
  font-size: 13px;
  color: #666;
  margin-bottom: 12px;
  line-height: 1.4;
}
.pizza-tamaños {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 15px;
}
.tamaño-badge {
  background: #f0f0f0;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
}
.pizza-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pizza-rating {
  font-size: 13px;
  color: #ffc107;
}
.add-btn {
  background: #cc0000;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 25px;
  cursor: pointer;
  font-weight: bold;
}

/* Combos */
.combos-section {
  padding: 50px 0;
  background: white;
}
.combos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
}
.combo-card {
  text-align: center;
  padding: 25px;
  background: #fff9f5;
  border-radius: 16px;
  border: 1px solid #ffe0cc;
}
.combo-img {
  font-size: 48px;
  margin-bottom: 15px;
}
.combo-card h3 {
  color: #333;
  margin-bottom: 8px;
}
.combo-price {
  font-size: 24px;
  font-weight: bold;
  color: #cc0000;
  margin: 10px 0 5px;
}
.combo-old {
  font-size: 14px;
  text-decoration: line-through;
  color: #999;
}
.combo-btn {
  background: #cc0000;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 25px;
  cursor: pointer;
  margin-top: 15px;
}

/* Benefits */
.benefits-section {
  padding: 40px 0;
  background: #fff0e6;
}
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  text-align: center;
}
.benefit div {
  font-size: 40px;
  margin-bottom: 10px;
}
.benefit h4 {
  margin-bottom: 5px;
}
.benefit p {
  font-size: 12px;
  color: #666;
}

/* Footer */
.footer {
  background: #1a1a1a;
  color: #999;
  padding: 40px 0 20px;
}
.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 40px;
  margin-bottom: 30px;
}
.footer-grid h4 {
  color: white;
  margin-bottom: 15px;
}
.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #333;
  font-size: 12px;
}

/* Cart floating */
.cart-floating {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #cc0000;
  border-radius: 50px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  z-index: 999;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}
.cart-icon {
  font-size: 24px;
  position: relative;
}
.cart-badge {
  position: absolute;
  top: -10px;
  right: -12px;
  background: white;
  color: #cc0000;
  border-radius: 50%;
  padding: 2px 7px;
  font-size: 11px;
  font-weight: bold;
}
.cart-total {
  background: white;
  color: #cc0000;
  padding: 5px 12px;
  border-radius: 30px;
  font-weight: bold;
}

/* Modales */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-container {
  background: white;
  border-radius: 20px;
  max-width: 550px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #eee;
}
.modal-close {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}
.modal-body {
  padding: 22px;
}
.empty-cart {
  text-align: center;
  padding: 40px;
}
.empty-cart div {
  font-size: 60px;
  margin-bottom: 15px;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  flex-wrap: wrap;
  gap: 10px;
}
.cart-item-name {
  font-weight: bold;
}
.cart-item-price {
  font-size: 12px;
  color: #cc0000;
}
.cart-item-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cart-item-actions button {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #ddd;
  background: white;
  cursor: pointer;
}
.remove-btn {
  background: none !important;
  border: none !important;
}
.cart-total-row {
  text-align: right;
  padding: 15px 0;
  font-size: 18px;
  border-top: 2px solid #eee;
  margin-top: 10px;
}
.checkout-btn,
.pay-btn {
  width: 100%;
  background: #cc0000;
  color: white;
  border: none;
  padding: 14px;
  border-radius: 30px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 15px;
}

.order-summary {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 12px;
  margin-bottom: 20px;
}
.order-item {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
}
.order-total {
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #ddd;
  font-weight: bold;
}
.input-field,
.textarea-field {
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #ddd;
  border-radius: 10px;
}
.textarea-field {
  resize: vertical;
}
.payment-methods {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 15px 0;
}
.payment-methods label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.toast {
  position: fixed;
  bottom: 100px;
  right: 30px;
  background: #28a745;
  color: white;
  padding: 12px 20px;
  border-radius: 30px;
  z-index: 1001;
  animation: slideIn 0.3s ease;
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .hero-text h1 {
    font-size: 28px;
  }
  .hero-image {
    display: none;
  }
  .header-row {
    flex-direction: column;
    gap: 15px;
  }
  .delivery-info {
    font-size: 12px;
  }
  .pizzas-grid {
    grid-template-columns: 1fr;
  }
}
</style>
